/**
 * @file 评分
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {Rate, Tooltip} from 'antd';
import classNames from 'classnames';

import {RateProps} from 'antd/es/rate';

interface RateNodeProps {
    index: number;
}

interface IProps extends RateProps {
}


const tooltipsText = ['文档没法使用', '文档较差', '文档一般', '文档不错', '文档很棒'];

const characterRender = (
    node: React.ReactElement,
    {index}: RateNodeProps
) => {
    return (
         // @ts-ignore
        <Tooltip
            overlayClassName="paddle-doc-rate-tooltip"
            title={tooltipsText[index]}
            align={{offset: [0, 5]}}
        >
            {node}
        </Tooltip>
    );
};

const rate: React.FC<IProps> = (props) => {

    return (
        // @ts-ignore
        <Rate
            className={classNames(props.className, 'paddle-doc-rate')}
            {...{
                characterRender: characterRender
            }}
            {...props}
        />
    );
};

export default rate;
